import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-input-dialogue',
    imports: [FormsModule],
    templateUrl: './input-dialogue.component.html',
    styleUrl: './input-dialogue.component.sass'
})
export class InputDialogueComponent {
    @Input() message: string = '';
    @Input() placeholder: string = '';
    @Input() value: string = '';
    @Input() label: string = '';

    get data(): { value: string } {
        return { value: this.value?.trim() ?? '' };
    }

    validate(): boolean {
        return !!this.value?.trim();
    }
}
